import React, { useState, useEffect } from 'react'
import TuneIcon from '@mui/icons-material/Tune';
import moment from 'moment';
import { getRefrenceCountByDate, getLoanStatusRefrenceByDate,getRejectionStatusRefrenceByDate,getConversionDetailsRefrenceByDate, getDisbursedStatsRefrenceByDate } from '../ActionCreator';
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import DailyLeadRecieved from "../../../../../Marketing/maketingComponents/screens/components/dashboard/dailyLeadRecieved";
import CountLeads from "../../../../../Marketing/maketingComponents/screens/components/dashboard/countLeads";
import RejectionStats from "../../../../../Marketing/maketingComponents/screens/components/dashboard/rejectionStats";
import ConversionRatio from "../../../../../Marketing/maketingComponents/screens/components/dashboard/conversionRatio";
import Stats from "../../../../../Marketing/maketingComponents/screens/components/Stats";

export default function ReferralDashboard({ Data }) {
      const [loader, setLoader] = useState(false);
      const [disbursedData, setDisbursedData] = useState({});
    const [dashboardcounts, setdashboardcounts] = useState({})
    const [rejectReasonData, setRejectReasonData] = useState([]);
    const [countStatusData, setCountStatusData] = useState([]);
    const [conversionRatioData, setConversionRatioData] = useState({});
    const [payload, setPayload] = useState({
        filter: "Daily",
        fromDate: moment(new Date()).format("YYYY-MM-DD"),
        toDate: moment(new Date()).format("YYYY-MM-DD"),
    })

    useEffect(() => {
        applyFilter()
    }, [])

    const handleChange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const applyFilter = () => {
        getRefrenceCountByDateFn()
        getLoanStatusRefrenceByDateFn()
        getRejectionStatusRefrenceByDateFn()
        getConversionDetailsRefrenceByDateFn()
        getDisbursedStatsRefrenceByDateFn()
    }

    const getRefrenceCountByDateFn = () => {
        const start = moment(payload?.fromDate)?.format("DD-MM-YYYY")
        const end = moment(payload?.toDate)?.format("DD-MM-YYYY")
        setLoader(true)
        getRefrenceCountByDate(start, end, Data?.referenceCode, Callback => {
            setLoader(false)
            setdashboardcounts(Callback)
        })
    }
    const getLoanStatusRefrenceByDateFn = () => {
        const start = moment(payload?.fromDate)?.format("DD-MM-YYYY")
        const end = moment(payload?.toDate)?.format("DD-MM-YYYY")
        setLoader(true)
        getLoanStatusRefrenceByDate(start, end, Data?.referenceCode, Callback => {
            setLoader(false)
            setCountStatusData(Callback)
        })
    }
    const getRejectionStatusRefrenceByDateFn = () => {
        const start = moment(payload?.fromDate)?.format("DD-MM-YYYY")
        const end = moment(payload?.toDate)?.format("DD-MM-YYYY")
        setLoader(true)
        getRejectionStatusRefrenceByDate(start, end, Data?.referenceCode, Callback => {
            setLoader(false)
            setRejectReasonData(Callback)
        })
    }
    const getConversionDetailsRefrenceByDateFn = () => {
        const start = moment(payload?.fromDate)?.format("DD-MM-YYYY")
        const end = moment(payload?.toDate)?.format("DD-MM-YYYY")
        setLoader(true)
        getConversionDetailsRefrenceByDate(start, end, Data?.referenceCode, Callback => {
            setLoader(false)
            setConversionRatioData(Callback)
        })
    }
    const getDisbursedStatsRefrenceByDateFn = () => {
        const start = moment(payload?.fromDate)?.format("DD-MM-YYYY")
        const end = moment(payload?.toDate)?.format("DD-MM-YYYY")
        setLoader(true)
        getDisbursedStatsRefrenceByDate(start, end, Data?.referenceCode, Callback => {
            setLoader(false)
            setDisbursedData(Callback)
        })
    }
    return (
        <>
        {
            loader ? <Loader /> :""
        }
            <div className="container-fluid marketing-main-css" style={{ marginTop: '20px' }}>
                <div className="row">
                    <div className="col-sm-2 col-xs-12">
                        <TuneIcon />
                        <span className="ms-3 filterHeaders">Filter</span>
                        <select
                            name=""
                            id=""
                            value={payload.filter}
                            className="form-select"
                            onChange={(e) => handleChange(e, "filter")}
                            style={{ width: '100%', padding: '10px', color: '#000' }}
                        >
                            <option value="daily">Daily</option>
                        </select>
                    </div>

                    <div className="col-sm-2 col-xs-12">
                        From
                        <input
                            type="date"
                            id="startDate"
                            placeholder="DD/MM/YY"
                            name="fromDate"
                            value={payload.fromDate}
                            onChange={(e) => handleChange(e, "fromDate")}
                            className=" form-control"
                            style={{
                                border: "1px solid gray",
                                borderRadius: "6px",
                                padding: "10px",
                            }}
                        />

                    </div>


                    <div className="col-sm-2 col-xs-12">
                        <div className="filterHeaders" style={{ marginTop: '4px' }}>to</div>
                        <input
                            type="date"
                            id="endDate"
                            name="toDate"
                            value={payload.toDate}
                            onChange={(e) => handleChange(e, "toDate")}
                            placeholder="DD/MM/YY"
                            className=" form-control"
                            style={{
                                border: "1px solid gray",
                                borderRadius: "6px",
                                padding: "10px",
                            }}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button
                            className="btn btn-primary mt-4 "
                            style={{
                                marginTop: '27px',
                                padding: '9px',
                                borderRadius: '5px'
                            }}
                            onClick={() => applyFilter()}
                        >
                            Apply Filter
                        </button>
                    </div>

                </div>

                <hr />
                <div className="row" style={{ marginBottom: '20px' }}>
                    <div className="col-sm-3 col-xs-12">
                        <div className="new-card-market">
                            <h4 style={{ color: '#999999' }}>Total Users</h4>
                            <h3 style={{ marginTop: '5px' }}><strong>{dashboardcounts?.totalUsers || 0}</strong></h3>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className="new-card-market">
                            <h4 style={{ color: '#999999' }}>Total Applied Leads</h4>
                            <h3 style={{ marginTop: '5px' }}><strong>{dashboardcounts?.totalLoans || 0}</strong></h3>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className="new-card-market">
                            <h4 style={{ color: '#999999' }}>Total Disbursed Leads</h4>
                            <h3 style={{ marginTop: '5px' }}><strong>{dashboardcounts?.totalDisbursedLeads || 0}</strong></h3>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className="new-card-market">
                            <h4 style={{ color: '#999999' }}>Total Cost Utilised (Till Date)</h4>
                            <h3 style={{ marginTop: '5px' }}><strong>{dashboardcounts?.totalApprovedLeads || 0}</strong></h3>
                        </div>
                    </div>

                </div>
                <div className="row mt-4">
                    {/* <div className="col-sm-6 col-xs-12">
                        <DailyLeadRecieved data={totalLeadsRecievedData} />
                    </div> */}
                    <div className="col-sm-12 col-xs-12">
                        {countStatusData ? <CountLeads data={countStatusData} /> : ""}
                    </div>
                </div>

                <div className="row " >

                    <div className="col-sm-5 col-xs-12">
                        <RejectionStats data={rejectReasonData}  customMinHeight={"330px"}/>
                    </div>

                    <div className="col-sm-7 col-sm-12 mt-4">
                        <ConversionRatio data={conversionRatioData} />
                    </div>
                </div>
                



                {Object.keys(disbursedData).length > 0 && (
                    <div className="">
                        <Stats data={disbursedData} />
                    </div>
                )}

            </div>
        </>
    )
}
